import React from "react"
import { Flex, Text } from "@chakra-ui/react"
import { Guest, GuestSummary } from "sharedTypes"
import GuestAvatar from "./GuestAvatar"

type Props = {
  guest: Guest | GuestSummary
  fontSize?: string
}

const GuestAvatarAndName = ({
  guest: {
    personInfo: {
      firstName,
      lastName,
      photoUrl,
    },
    status,
    checkedIn,
  },
  fontSize = "sm",
}: Props) => (
  <Flex gap={4}>
    <GuestAvatar
      firstName={firstName}
      lastName={lastName}
      photoUrl={photoUrl}
      status={status}
      checkedIn={!!checkedIn}
    />
    <Flex alignItems="center" fontSize={fontSize}>
      <Text fontWeight="semibold">{firstName}</Text>&nbsp;<Text>{lastName}</Text>
    </Flex>
  </Flex>
)

export default GuestAvatarAndName
